// Field option lists + mappings for the PESO Panglao registration portal.
// The job-seeker flow is a 1:1 digital replica of the DOLE NSRP Jobseeker Form 1;
// the employer flow replicates PESO Panglao's Google intake form.

// --- Panglao barangays (NSRP present-address + employer location) ---
export const PANGLAO_BARANGAYS = [
  'Bil-isan', 'Bolod', 'Danao', 'Doljo', 'Libaong',
  'Looc', 'Lourdes', 'Poblacion', 'Tangnan', 'Tawala',
];

// ===================== NSRP JOBSEEKER (Form 1) =====================

export const NSRP_SEX = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const NSRP_CIVIL_STATUS = [
  { value: 'single', label: 'Single' },
  { value: 'married', label: 'Married' },
  { value: 'widowed', label: 'Widowed' },
  { value: 'separated', label: 'Separated' },
  { value: 'others', label: 'Others' },
];

export const NSRP_DISABILITIES = [
  { value: 'visual', label: 'Visual' },
  { value: 'hearing', label: 'Hearing' },
  { value: 'speech', label: 'Speech' },
  { value: 'physical', label: 'Physical' },
  { value: 'others', label: 'Others' },
];

// Section II — employment status / type
export const NSRP_EMPLOYMENT_STATUS = [
  { value: 'employed', label: 'Employed' },
  { value: 'unemployed', label: 'Unemployed' },
  { value: 'wage_employed', label: 'Wage Employed' },
  { value: 'self_employed', label: 'Self Employed' },
];

export const NSRP_SEPARATION_REASONS = [
  { value: 'new_entrant', label: 'New Entrant/Fresh Graduate' },
  { value: 'terminated_local', label: 'Terminated/Laid off (local)' },
  { value: 'terminated_abroad', label: 'Terminated/Laid off (abroad)' },
  { value: 'finished_contract', label: 'Finished Contract' },
  { value: 'resigned', label: 'Resigned' },
  { value: 'retired', label: 'Retired' },
];

export const NSRP_EMPLOYMENT_TYPE_PREF = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
];

// Section IV — language/dialect proficiency
export const NSRP_LANGUAGES = ['English', 'Filipino', 'Mandarin'];
export const NSRP_LANG_SKILLS = [
  { value: 'read', label: 'Read' },
  { value: 'write', label: 'Write' },
  { value: 'speak', label: 'Speak' },
  { value: 'understand', label: 'Understand' },
];

// NSRP Form 1.REV 3 — Language Proficiency Certification (§V) + Dialects Spoken
export const NSRP_LANG_CERTS = ['IELTS', 'TOEFL', 'TOCFL', 'JLPT', 'TOPIK', 'Others'];
export const NSRP_DIALECTS = ['Tagalog', 'Ilocano', 'Ilonggo', 'Bikol', 'Others'];

// NSRP Form 1.REV 3 — §VII 21st Century Skills (check five)
export const NSRP_21C_SKILLS = [
  'Innovation', 'Team Work', 'Multitasking', 'Work Ethics', 'Self Motivation',
  'Creative Problem Solving', 'Problem Solving', 'Critical Thinking', 'Decision Making', 'Stress Tolerance',
  'Planning and Organizing', 'Social Perceptiveness', 'English Functional Skills', 'English Comprehension', 'Math Functional Skill',
];

// NSRP Form 1.REV 3 — highest educational level (§III)
export const NSRP_HIGHEST_EDUCATION = [
  { value: 'no_formal', label: 'No formal education' },
  { value: 'elem_level', label: 'Elementary Level' },
  { value: 'elem_grad', label: 'Elementary Graduate' },
  { value: 'hs_level', label: 'High School Level' },
  { value: 'hs_grad', label: 'High School Graduate' },
  { value: 'col_level', label: 'College level' },
  { value: 'col_grad', label: 'College Graduate' },
  { value: 'tvet', label: 'Technical-vocational graduate' },
  { value: 'post_grad', label: 'Post Graduate' },
];

// Section V — education (the NSRP form's own level list)
export const NSRP_EDUCATION_LEVELS = [
  { value: 'elementary', label: 'Elementary' },
  { value: 'secondary_non_k12', label: 'Secondary (Non-K12)' },
  { value: 'secondary_k12', label: 'Secondary (K-12)' },
  { value: 'senior_high', label: 'Senior High' },
  { value: 'tertiary', label: 'Tertiary' },
  { value: 'graduate_studies', label: 'Graduate Studies' },
];

export const SENIOR_HIGH_STRANDS = [
  'ABM', 'STEM', 'HUMSS', 'GAS', 'TVL', 'Arts and Design', 'Sports',
];

// Section VI — technical/vocational training certificates
export const NSRP_NC_CERTS = ['NC I', 'NC II', 'NC III', 'NC IV', 'Other'];

// Section VIII — work experience appointment status
export const NSRP_APPOINTMENT_STATUS = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'contractual', label: 'Contractual' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'probationary', label: 'Probationary' },
];

// §VIII — Technical Skills Acquired Without Formal Training checklist (REV 3)
export const NSRP_OTHER_SKILLS = [
  'Carpentry', 'Masonry', 'Welding', 'Auto Mechanic', 'Plumbing', 'Driving',
  'Gardening', 'Tailoring', 'Photography', 'Hairdressing', 'Cooking', 'Baking',
  'Others',
];

// Map NSRP education level -> Bohol Trabaho profile education_level enum (typed column)
export const NSRP_TO_BT_EDUCATION = {
  elementary: 'elementary',
  secondary_non_k12: 'high_school',
  secondary_k12: 'high_school',
  senior_high: 'high_school',
  tertiary: 'college_graduate',
  graduate_studies: 'masters',
};

// Map the §III "Highest Educational Level" select -> Bohol Trabaho education_level.
// This is the RELIABLE source for the typed education_level column (a single required
// select), so the profile is complete even if the seeker leaves the §V education rows
// blank — closing the gap that used to force PESO seekers onto /complete-profile.
export const NSRP_HIGHEST_TO_BT = {
  no_formal: 'elementary',
  elem_level: 'elementary',
  elem_grad: 'elementary',
  hs_level: 'high_school',
  hs_grad: 'high_school',
  col_level: 'college_level',
  col_grad: 'college_graduate',
  tvet: 'vocational',
  post_grad: 'masters',
};

// ===================== EMPLOYER (PESO Google form) =====================

// Panglao PESO job categories (the labels their form uses)
export const PANGLAO_JOB_CATEGORIES = [
  'Tourism & Hospitality Services',
  'Food & Beverage Services',
  'Travel, Tours, and Recreation',
  'Administrative & Support Staff',
  'Maintenance & Facility Services',
  'Retail & Customer Service',
  'Cultural, Creative, and Local Enterprise',
  'Environmental and Community Services',
  'Construction & Skilled Work',
  'Others',
];

// Map each Panglao category -> the nearest Bohol Trabaho category NAME (resolved to
// an id at submit by matching against GET /api/categories). The original Panglao
// label is preserved in the job description so nothing is lost.
export const PANGLAO_TO_BT_CATEGORY = {
  'Tourism & Hospitality Services': 'Hospitality & Tourism',
  'Food & Beverage Services': 'Food & Beverage',
  'Travel, Tours, and Recreation': 'Hospitality & Tourism',
  'Administrative & Support Staff': 'Other',
  'Maintenance & Facility Services': 'Other',
  'Retail & Customer Service': 'Retail',
  'Cultural, Creative, and Local Enterprise': 'Other',
  'Environmental and Community Services': 'Other',
  'Construction & Skilled Work': 'Construction',
  'Others': 'Other',
};

export const PESO_EMPLOYMENT_TYPES = [
  { value: 'full_time', label: 'Full Time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'seasonal_contractual', label: 'Seasonal/Contractual' },
];

export const REGISTRATION_SOURCE = 'peso_panglao';
export const PESO_REFERRAL_CODE = 'PESO-PANGLAO';

// ===================== EMPLOYER — NSRP Reg Form 2 (Revised September 2017) =====================
// Verbatim from the official Form 2 (DOLE NATIONAL SKILLS REGISTRATION PROGRAM, Establishment
// Registration Form). Do NOT paraphrase — the digital form must reflect the paper form exactly.

// Section I — Employer type ("check only 1")
export const EMPLOYER_TYPES = [
  'Government',
  'Private',
  'Recruitment & Placement Agency (Local)',
  'Licensed Recruitment Agency (Overseas)',
  'DO 174-17, Subcontractor',
];

// Section I — Total Work Force
export const WORK_FORCE_BUCKETS = ['Micro (1-9)', 'Small (10-99)', 'Medium (100-199)', 'Large (200 and up)'];

// Lossy coarsening: NSRP has 4 size buckets, Bohol Trabaho has 6; 'Small (10-99)' collapses the
// platform's 6-10/11-50/51-100 into '11-50'. The RAW NSRP bucket is always preserved in
// nsrp_data.establishment.work_force; this map only sets the typed number_of_employees column so
// PESO employers still appear in size-based analytics (all 4 targets are valid platform buckets).
export const WORK_FORCE_TO_BT = {
  'Micro (1-9)': '1-5',
  'Small (10-99)': '11-50',
  'Medium (100-199)': '101-500',
  'Large (200 and up)': '500+',
};

// Section III — Nature of Work (6 options). {value,label}: the STABLE slug (value) drives
// NATURE_TO_JOB; the verbatim label ("Internship / OJT", "Work from home / online job" — spaces
// around the slashes, exactly as printed) is what we store + print.
export const NATURE_OF_WORK = [
  { value: 'permanent', label: 'Permanent' },
  { value: 'contractual', label: 'Contractual' },
  { value: 'project_based', label: 'Project-based' },
  { value: 'internship_ojt', label: 'Internship / OJT' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'wfh', label: 'Work from home / online job' },
];

// Map the Nature-of-Work slug -> the marketplace job's typed columns.
// jobs.type is free-text (display-only, NOT a search filter — Jobs.js filters on post_type).
// work_schedule MUST be one of exactly 'full_time' | 'part_time' (the only two options in PostJob).
export const NATURE_TO_JOB = {
  permanent: { type: 'permanent', work_schedule: 'full_time' },
  contractual: { type: 'contract', work_schedule: 'full_time' },
  project_based: { type: 'contract', work_schedule: 'full_time' },
  internship_ojt: { type: 'seasonal', work_schedule: 'full_time' },
  part_time: { type: 'permanent', work_schedule: 'part_time' },
  wfh: { type: 'permanent', work_schedule: 'full_time' },
};

// Build-time assert: every NATURE_OF_WORK value must have a NATURE_TO_JOB mapping. Guards against
// a future edit to the option list that would silently publish an unmapped nature (jobs.type is
// free-text + PESO publish bypasses validation, so an unmapped value would go live, not 400).
NATURE_OF_WORK.forEach((o) => {
  if (!NATURE_TO_JOB[o.value]) {
    // eslint-disable-next-line no-console
    console.error(`[pesoFields] NATURE_TO_JOB is missing a mapping for "${o.value}"`);
  }
});

// Section IV — Sex / Civil Status PREFERENCES (employer's applicant preference; 3 options each).
// NEW lists — do NOT reuse the jobseeker NSRP_SEX / NSRP_CIVIL_STATUS (different option sets).
export const SEX_PREF = ['Male', 'Female', 'No Preference'];
export const CIVIL_STATUS_PREF = ['Single', 'Married', 'No Preference'];

// Section IV — Accepts Disability sub-types (shown when "Yes")
export const ACCEPTS_DISABILITY_TYPES = ['Visual', 'Hearing', 'Speech', 'Physical', 'Others (please specify)'];

// Section IV — Accepts (government/livelihood programs)
export const ACCEPTS_PROGRAMS = ['PESO', 'SPES', 'GIP', 'JobStart Philippines', 'K-12 AMP', 'TraBAJO'];

// Section II — Title of the contact person
export const TITLE_OPTIONS = ['Mr.', 'Ms.', 'Miss', 'Others (please specify)'];
